module.exports = __webpack_public_path__ + "media/brands/lti-4f141061.png";